// Kept in sync with @email_format in Sunergos.Schema.User: no whitespace or address-list
// separators, exactly one "@", and a dotted domain ending in an alphabetic TLD. Catching
// this client-side saves the user a round-trip; the server validates the same thing regardless.
const EMAIL_FORMAT = /^[^\s@,;:<>"]+@[^\s@,;:<>".]+(\.[^\s@,;:<>".]+)*\.[A-Za-z]{2,}$/

// Narrow exception, mirrored from @placeholder_email_format on the server: installers
// register customers without an email address as `name@invalid` (the reserved TLD of
// RFC 2606, no dot). The server never sends mail to that domain.
const PLACEHOLDER_EMAIL_FORMAT = /^[^\s@,;:<>"]+@invalid$/i

export function isValidEmail(value: string | null | undefined): boolean {
  if (!value) {
    return false
  }
  const email = value.trim()
  return EMAIL_FORMAT.test(email) || PLACEHOLDER_EMAIL_FORMAT.test(email)
}
